import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-instagram-icon",
  template: `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.121 20">
      <path
        id="facebook"
        d="M52.121,43.41a10.06,10.06,0,1,0-11.632,9.939v-7.03H37.933V43.41h2.555V41.194a3.551,3.551,0,0,1,3.8-3.915,15.46,15.46,0,0,1,2.252.2v2.476H45.272a1.455,1.455,0,0,0-1.64,1.572V43.41h2.79l-.446,2.909H43.632V53.35A10.063,10.063,0,0,0,52.121,43.41Z"
        transform="translate(-32 -33.35)"
        fill="#f27c00"
        fill-rule="evenodd"
      />
    </svg>
  `,
  styles: [
    `
      svg {
        display: block;
      }
    `,
  ],
})
export class InstagramIconComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
